import classes from './ECommerce.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Link} from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const ECommerce = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
            
    const title = t('eCommerce.title')
    const description = t('eCommerce.text', {returnObjects: true})

    const blackBlocks = t('eCommerce.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('eCommerce.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('eCommerce.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('eCommerce.benefitBlocks', {returnObjects: true})

    const stories = t('eCommerce.stories', {returnObjects: true})



    const useCaseText = t('eCommerce.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('eCommerce.Faq.left', {returnObjects: true}),
        right: t('eCommerce.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    E-commerce IT Solutions & Omnichannel Commerce Platforms | Goteco
                </title>
                <meta
                    name="description"
                    content="Scale your online business with high-performance e-commerce IT solutions. Automate inventory, optimize checkout, and enhance customer experience with secure, scalable platforms."
                />
                <link rel="canonical" href="https://go-te.co/industries/e-commerce" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={700}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('eCommerce.blackBlocksTitle')}</h3>
                        <p>{t('eCommerce.blackBlocksText')}</p>
                        <p>{t('eCommerce.blackBlocksText2')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('eCommerce.challengesBlocksTitle')}</h2>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('eCommerce.solutionsBlocksTitle')}</h2>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('eCommerce.benefitBlocksTitle')}</h2>
                        <p>{t('eCommerce.benefitBlocksText')}</p>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('eCommerce.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('eCommerce.useCase')}</h2>
                            <div className={classes.text}>
                                <img src={eRoadImg} alt="E-commerce use case"/>
                                <p>{useCaseText}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('eCommerce.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('eCommerce.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img className={classes.img} src={eRoadImg} alt="E-commerce system"/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard 
                            title={t('eCommerce.formCard.title')}
                            message={t('eCommerce.formCard.message')}
                            buttonText={t('eCommerce.formCard.buttonText')}
                            labels={t('eCommerce.formCard.labels', {returnObjects: true})}
                            top={3} id='contact'/>
                </section>

                <section className="section--light-gray" id="nav-dark">
                    <FrequentlyAskedQuestions title={t('eCommerce.Faq.title')} questions={questions}/>
                </section>
            </main>
        </>

    );
};

export default ECommerce;